import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/components/dashboard/dashboard.component';
import { UserManagementComponent } from './management/components/user-management/user-management.component';
import { LayoutComponent } from '@views/public/layout/layout.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { AuthGuard } from '@core/guards/auth.guard';
import { UserAddComponent } from './management/components/user-management/user-add/user-add.component';
import { ResourcesFormComponent } from './resources/components/resources-form/resources-form.component';
import { CourseComponent } from './course/course.component';
import { CourseUserComponent } from './courses/components/course-user/course-user.component';
import { ReportCardsComponent } from './report/report-cards/report-cards.component';
import { ReportComponent } from './report/report.component';
import { ReportCourseViewComponent } from './report/report-course-view/report-course-view.component';
import { DistrictManagementComponent } from './management/components/district-management/district-management.component';
import { SchoolManagementComponent } from './management/components/school-management/school-management.component';
import { userRouteGuard } from '@core/guards/user-guard.guard';
import { ReportCompletionViewComponent } from './report/report-completion-view/report-completion-view.component';
import { ExternalResourcesComponent } from './resources/components/external-resources/external-resources.component';
import { FAQComponent } from '@views/public/faq/faq.component';
import { AboutComponent } from '@views/public/about/about.component';
import { FacilitationGuideComponent } from './resources/components/facilitation-guide/facilitation-guide.component';
import { SiteOfflineGuard } from '@core/guards/site-offline-guard';

const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard, SiteOfflineGuard],
    component: LayoutComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent, title: 'Home' },
      { path: 'user-management', component: UserManagementComponent, canActivate: [userRouteGuard], title: 'User Management' },
      { path: 'district-management', component: DistrictManagementComponent, canActivate: [userRouteGuard], title: 'District Management' },
      { path: 'school-management', component: SchoolManagementComponent, canActivate: [userRouteGuard], title: 'School Management' },
      { path: 'school-management/:districtId', component: SchoolManagementComponent, canActivate: [userRouteGuard], title: 'School Management' },
      { path: 'user-add', component: UserAddComponent, canActivate: [userRouteGuard], title: 'Add User' },
      { path: 'account-settings', component: AccountSettingsComponent, title: 'Account Settings' },
      { path: 'course/:courseId', component: CourseComponent, title: 'Course' },
      { path: 'course/:courseId/:userCourseId', component: CourseComponent, title: 'Course' },
      { path: 'courses', component: CourseUserComponent, title: 'Courses' },
      { path: 'resources', component: ExternalResourcesComponent, title: 'Resources' },
      { path: 'resources/form', component: ResourcesFormComponent, title: 'Resources' },
      { path: 'resources/form/:id', component: ResourcesFormComponent, title: 'Resources' },
      { path: 'resources/facilitation-guide', component: FacilitationGuideComponent, title: 'Facilitation Guide' },
      // { path: 'about', component: AboutComponent },
      // { path: 'faq', component: FAQComponent },
      // { path: 'resources/impact-video/form', component: ResourcesFormComponent },
      // { path: 'resources/impact-video/form/:id', component: ResourcesFormComponent },
      {
        path: 'report',
        component: ReportComponent,
        title: 'Reports',
        canActivate: [userRouteGuard],
        children: [
          { path: '', component: ReportCardsComponent, title: 'Reports' },
          { path: 'report-cards', component: ReportCardsComponent, title: 'Reports' },
          { path: 'report-course-view', component: ReportCourseViewComponent, title: 'Reports' },
          { path: 'report-completion-view', component: ReportCompletionViewComponent, title: 'Reports' }
        ]
      },
    ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FeaturesRoutingModule { }
